function orderBtnStatus() {
  
  var showbutton = true;
  var eStyle = $('#SingleOptionSelector-0').val();
  var eSize = $('#SingleOptionSelector-1').val();
  var eColor = $('#SingleOptionSelector-2').val();
  var ePlacement = $('#graphic-placement').val();  
  
  if (eStyle == 'Please Select') { showbutton = false; }
  if (eSize == 'Please Select') { showbutton = false; }
  if (eColor == 'Please Select') { showbutton = false; }
  if (ePlacement == 'Please Select') { showbutton = false; }
  
  if (showbutton == true) {
	$('#addToCart-product-template').show();
    $('#optionserror').hide();
  } else {
    $('#addToCart-product-template').hide();
    $('#optionserror').show();    
  }
  
}

function buildOptions(idSelect,arrOptions) {
  var strOptions = '';
  for (i=0; i<arrOptions.length; i++) {
    strOptions = strOptions + '<option value="' + arrOptions[i] + '">' + arrOptions[i] + '</option>';
  }
  
  idSelect.html(strOptions);
  
  if(arrOptions.length < 2) {
    idSelect.prop('disabled',true);
    idSelect.addClass('disabled');
  } else {
    idSelect.prop('disabled',false);
    idSelect.removeClass('disabled');
  }
  
  orderBtnStatus();
  
}

$(document).ready(function(){
  
  	/* intialize options */    
	buildOptions($('#SingleOptionSelector-0'),Styles);
	buildOptions($('#SingleOptionSelector-1'),empty);
  	buildOptions($('#SingleOptionSelector-2'),empty);
  
    $('#SingleOptionSelector-0').on('change', function(){
      
      var currStyle = $('#SingleOptionSelector-0').val();        
      
      if (currStyle == 'Adult Short Sleeve Tee') {
  
        buildOptions($('#SingleOptionSelector-1'),adultSizes);
        
      } else if (currStyle == 'Ladies Short Sleeve Tee') {
        
      	buildOptions($('#SingleOptionSelector-1'),ladiesSizes);
        
      } else {
        
        buildOptions($('#SingleOptionSelector-1'),empty);
      }  
      
      buildOptions($('#SingleOptionSelector-2'),empty);      
        
    });  

  
    $('#SingleOptionSelector-1').on('change', function(){
      
      var currStyle = $('#SingleOptionSelector-0').val();
      var currSize = $(this).val();    
      
      if (currSize == 'Please Select') {
  
        buildOptions($('#SingleOptionSelector-2'),empty);
    
      } else if (currStyle == 'Adult Short Sleeve Tee' && currSize == '4X Large (+$3.00)') {
  
        buildOptions($('#SingleOptionSelector-2'),adult4xColors);
        
      } else if (currStyle == 'Adult Short Sleeve Tee') {
        
 		buildOptions($('#SingleOptionSelector-2'),adultColors);
        
      } else if (currStyle == 'Ladies Short Sleeve Tee') {
        
        buildOptions($('#SingleOptionSelector-2'),ladiesColors);
        
      } else {
        
        buildOptions($('#SingleOptionSelector-2'),empty);
      }
        
    });  
  
  	$('#SingleOptionSelector-2').on('change', function(){
       orderBtnStatus();      
	});
  
  	$('#graphic-placement').on('change', function(){
       orderBtnStatus();      
	});  
  
  
});